var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"title":_vm.$t('segmentation.title')}},[_c('div',{class:_vm.prefixCls},[_c('HaiUpload',{attrs:{"maxSize":10},on:{"onChange":_vm.onSubmitFile}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }